import { render, staticRenderFns } from "./branding-header.vue?vue&type=template&id=240d439b&scoped=true&"
var script = {}
import style0 from "./branding-header.vue?vue&type=style&index=0&id=240d439b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d439b",
  null
  
)

export default component.exports